

const user = {
  state: {
    count: 0,
    age: 30,
    sex: '男',
    name:'魏建波'
  },
  // 事件处理器  increment事件类型    state.count++ 事件响应内容   同步的  commit
  mutations: {
    increment (state) {
      state.count++
    },
    increment2 (state,num) {
      state.count = state.count+num
    },
    increment3 (state,obj) {
      state.count = state.count+obj.num
    },
  },
  // 异步处理   dispatch使用
  actions: {
    increment(ctx,num){
      setTimeout(()=>{
        ctx.commit('increment2',num);
      },3000)
    }
  },
 /* getters: {
    getString: state => {
      return state.name+","+state.sex+","+state.age;
    }
  }*/
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js